import React, { useMemo, useState, useEffect } from "react";
import "./css/Syllabus.css";

/*
Update these arrays to match actual PDF file names inside:

public/Sayllabus/class_IX/
public/Sayllabus/class_X/
public/Sayllabus/class_XII/
public/Sayllabus/class_XII_Humanities/

"name" = file name without .pdf
*/

const syllabusData = {
  IX: [
    { name: "Split up of Syllabus IX", title: "Split up of Syllabus IX_2025-26" },
  ],

  X: [
    { name: "Split up of Syllabus X", title: "Split up of Syllabus X_2025-26" },
  ],

   XII_Science: [
    { name: "Split up of Syllabus XII Science", title: "Split up of Syllabus XII Science_2025-26" },
  ],

  XII_HUMANITIES: [
    { name: "Split up of Syllabus XII Humanities", title: "Split up of Syllabus XII Humanities_2025-26" },
  ],
};

/* Folder mapping */
const classFolderMap = {
  IX: "class_IX",
  X: "class_X",
  XII_Science: "class_XII_Science",
  XII_HUMANITIES: "class_XII_Humanities",
};

function buildPdfUrl(cls, name) {
  const folder = classFolderMap[cls];
  return `/Sayllabus/${folder}/${encodeURIComponent(name)}.pdf`;
}

export default function Syllabus() {
  const [activeClass, setActiveClass] = useState("X");
  const [selectedName, setSelectedName] = useState(
    syllabusData.X[0]?.name || ""
  );
  const [isLoadingPdf, setIsLoadingPdf] = useState(false);
  const [pdfError, setPdfError] = useState("");

  const list = useMemo(() => syllabusData[activeClass] || [], [activeClass]);

  useEffect(() => {
    if (!list.find((d) => d.name === selectedName)) {
      setSelectedName(list[0]?.name || "");
    }
  }, [activeClass, list, selectedName]);

  const selectedDoc = useMemo(
    () => list.find((d) => d.name === selectedName) || null,
    [list, selectedName]
  );

  const pdfUrl = selectedDoc ? buildPdfUrl(activeClass, selectedDoc.name) : "";

  useEffect(() => {
    if (selectedDoc) {
      setPdfError("");
      setIsLoadingPdf(true);
    } else {
      setPdfError("");
      setIsLoadingPdf(false);
    }
  }, [selectedDoc]);

  const classTabs = [
    { key: "IX", label: "Class IX" },
    { key: "X", label: "Class X" },
    { key: "XII_Science", label: "Class XII Science" },
    { key: "XII_HUMANITIES", label: "Class XII Humanities" },
  ];

  return (
    <div className="syllabus">
      <h2 id="h2" className="mt-3">SYLLABUS</h2>

      <div className="container my-4 d-flex flex-column flex-md-row">

        {/* LEFT SIDEBAR */}
        <div className="col-md-4 pe-md-3">
          <div className="card shadow-sm syllabus-card sidebar-sticky">

            <div className="card-header bg-white">
              <ul className="nav nav-pills gap-2 flex-wrap">
                {classTabs.map((cls) => {
                  const active = activeClass === cls.key;
                  return (
                    <li key={cls.key}>
                      <button
                        className={`nav-link ${active ? "active" : ""}`}
                        onClick={() => setActiveClass(cls.key)}
                      >
                        {cls.label}
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>

            <div className="card-body p-0">
              <ul className="list-group list-group-flush">
                {list.map((item) => {
                  const active = selectedName === item.name;
                  return (
                    <li
                      key={item.name}
                      className={`list-group-item list-group-item-action d-flex justify-content-between align-items-center ${active ? "active" : ""}`}
                      onClick={() => setSelectedName(item.name)}
                    >
                      <span className="text-truncate">{item.title}</span>
                      <span className={`badge ${active ? "bg-light text-dark" : "bg-secondary"}`}>
                        PDF
                      </span>
                    </li>
                  );
                })}
              </ul>

              {list.length === 0 && (
                <div className="alert alert-warning m-3">
                  No syllabus uploaded for {activeClass}
                </div>
              )}
            </div>

          </div>
        </div>

        {/* RIGHT VIEWER */}
        <div className="col-md-8 ps-md-3 mt-3 mt-md-0">
          <div className="card shadow-sm">

            <div className="card-header d-flex justify-content-between align-items-center bg-light-subtle">
              <div className="fw-semibold text-truncate">
                {selectedDoc ? selectedDoc.title : "Select syllabus"}
              </div>

              {selectedDoc && (
                <div className="d-flex gap-2">
                  <a
                    className="btn btn-success btn-sm"
                    href={pdfUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Open
                  </a>
                  <a
                    className="btn btn-danger btn-sm"
                    href={pdfUrl}
                    download
                  >
                    Download
                  </a>
                </div>
              )}
            </div>

            <div className="position-relative" style={{ minHeight: 420 }}>
              {selectedDoc ? (
                <>
                  {isLoadingPdf && !pdfError && (
                    <div className="position-absolute top-50 start-50 translate-middle text-center">
                      <div className="spinner-border"></div>
                      <div className="mt-2">Loading PDF…</div>
                    </div>
                  )}

                  {pdfError && (
                    <div className="p-4 text-danger">
                      Unable to load PDF. Try Open or Download.
                    </div>
                  )}

                  {!pdfError && (
                    <iframe
                      title={selectedDoc.title}
                      src={pdfUrl}
                      className="w-100"
                      style={{ height: "70vh", border: 0 }}
                      onLoad={() => setIsLoadingPdf(false)}
                      onError={() => {
                        setIsLoadingPdf(false);
                        setPdfError("Failed to load PDF");
                      }}
                    />
                  )}
                </>
              ) : (
                <div className="p-4 text-secondary">
                  No file selected.
                </div>
              )}
            </div>

          </div>
        </div>

      </div>
    </div>
  );
}
